import XLSX from 'xlsx';

const ExcelReader = (file, callback) => {
    let reader = new FileReader();
    reader.onload = function (e) {
        // pre-process data
        let binary = "";
        let bytes = new Uint8Array(e.target.result);
        let length = bytes.byteLength;
        for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
        }

        /* read workbook */
        let wb = XLSX.read(binary, {type: 'binary'});

        /* grab first sheet */
        let contactsSheetName = wb.SheetNames[0];
        let contactsSheet = wb.Sheets[contactsSheetName];
        let contacts = XLSX.utils.sheet_to_json(contactsSheet);
        console.log('raw contacts', contacts);

        let groupsSheetName = wb.SheetNames[1];
        let groupsSheet = wb.Sheets[groupsSheetName];
        let groups = XLSX.utils.sheet_to_json(groupsSheet);
        console.log('raw groups', groups);

        /* generate HTML */
        // let HTML = XLSX.utils.sheet_to_html(ws);
        // me.importData = HTML;

        //console.log('raw data', data);

        callback(contacts, groups);
    };

    reader.readAsArrayBuffer(file);
};

export default ExcelReader;